<div *ngIf="!loggedIn">
  <app-login *ngIf="currentAction === 'login'" class="login-content" (actionChange)="setAction($event)"></app-login>
  <app-register *ngIf="currentAction === 'register'" (actionChange)="setAction($event)"></app-register>
</div>
<div *ngIf="loggedIn">
  <app-maindashboard></app-maindashboard>
</div>

